import styles from "../../styles/Layout/Transactions/TransactionsPageWrapper.module.css"
import React, { useState, useContext } from 'react'
import { TransactionsLayoutSidebar } from "./TransactionsLayoutSidebar";
import { Title } from "../../components/UI/Custom/Title";
import { FilterTransactionModal } from "../../components/Modal/Transactions/FilterTransactionModal";
import { SettingsModal } from "../../components/Modal/Payments/SettingsModal";
import { useLocation } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";
import { LangContext } from "../../context/LangContext";

const translations = {
    ru: {
        title: "Транзакции",
    },
    en: {
        title: "Transactions",
    },
};

export const TransactionsPageWrapper = ({ children, tabsSelected, setTabsSelected }) => {
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
    const { langSelected } = useContext(LangContext);
    const { theme } = useContext(ThemeContext);
    const t = translations[langSelected] || translations.ru;
    const location = useLocation();

    const handleOpenSettings = () => {
        setIsSettingsModalOpen(true);
    };

    const handleCloseSettings = () => {
        setIsSettingsModalOpen(false);
    };

    const showSettingsButton = location.pathname.includes('/transactions');

    return (
        <div className={`${styles.wrapper} ${theme === 'dark' ? styles.darkWrapper : ''}`}>
            <Title
                h2={t.title}
                activeSpan={true}
                theme={theme}
            />
            <div className={`${styles.infoGrid} ${theme === 'dark' ? styles.darkInfoGrid : ''}`}>
                <div className={styles.tabs}>
                    <TransactionsLayoutSidebar onOpenSettings={handleOpenSettings} theme={theme} />
                </div>
                <div className={styles.pageContent}>
                    {children}
                </div>
            </div>

            {isFilterModalOpen && <FilterTransactionModal theme={theme} />}

            {isSettingsModalOpen && showSettingsButton && (
                <SettingsModal
                    onClose={handleCloseSettings}
                    theme={theme}
                    onSave={() => {
                        handleCloseSettings();
                    }}
                />
            )}
        </div>
    );
};
